var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeClosed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m10.898 7.103-3.795 3.795a2.682 2.682 0 1 1 3.795-3.795"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M13.365 4.327c-1.313-.99-2.813-1.53-4.365-1.53-2.648 0-5.115 1.56-6.833 4.26-.675 1.058-.675 2.835 0 3.893.593.93 1.283 1.733 2.033 2.378M6.315 14.648c.855.36 1.763.555 2.685.555 2.648 0 5.115-1.56 6.833-4.26.675-1.058.675-2.835 0-3.893-.248-.39-.518-.757-.795-1.102"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11.633 9.525a2.67 2.67 0 0 1-2.115 2.115M7.103 10.898 1.5 16.5M16.5 1.5l-5.602 5.603"
})));
export default SvgEyeClosed;